<template>
  <div class="pd-audioInfoWrapper">
    <div class="pd-textShowWrapper">
      <div class="pd-subTitle">{{ $t('audioDetails.subTitle') }}</div>
      <div class="pd-showText" v-if="isShow">
        {{ textArray[page] }}
      </div>
      <div v-else class="pd-showText">{{ audioInfo.text }}</div>
      <div v-if="isShow" class="pd-pagesBtnWrapper">
        <v-tooltip left>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn icon class="pd-pageBtn" @click="minusPage" v-on="tooltip">
              <ArrowLeftIcon color="white" />
            </v-btn>
          </template>
          <span>{{ $t('audioDetails.pageBtn1') }} </span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn icon class="pd-pageBtn" @click="plusPage" v-on="tooltip">
              <ArrowLeftIcon color="white" style="transform:rotate(180deg)" />
            </v-btn>
          </template>
          <span>{{ $t('audioDetails.pageBtn2') }} </span>
        </v-tooltip>
      </div>
      <div class="pd-fullScreenButton">
        <FullScreenInput :inputText="audioInfo.text" :isShow="isShow" :textArray="textArray" :currentPage="page" />
      </div>
    </div>

    <div class="pd-settingsWrapper">
      <div class="pd-settingsTitleWrapper">
        <div class="pd-settingsTitle">
          <div class="d-flex align-center" style="height: 18px; margin-right: 5px; gap:10px">
            <SettingsIcon />
            {{ $t('audioDetails.settings') }}
          </div>
        </div>
      </div>
      <div class="pd-toolsWrapper">
        <div>
          <div class="pd-audioTitleStyle">
            {{ $t('audioDetails.audioName') }}
            <span class="pd-audioInfoStyle">{{ audioInfo.name }}</span>
          </div>
          <div class="pd-audioTitleStyle">
            {{ $t('audioDetails.convertDate') }}
            <span class="pd-audioInfoStyle">{{ getFormatDate }}</span>
          </div>
          <div class="pd-audioTitleStyle">
            {{ $t('audioDetails.length') }}
            <span class="pd-audioInfoStyle">{{ audioInfo.text.length }}</span>
          </div>
          <div class="pd-audioTitleStyle">
            {{ $t('audioDetails.voice') }}
            <span class="pd-audioInfoStyle">{{ $t(getVoiceName) }}</span>
          </div>
          <div class="pd-audioTitleStyle">
            {{ $t('audioDetails.audioBackground') }}
            <span class="pd-audioInfoStyle">{{ $t(getBackgroundSound) }}</span>
          </div>
          <div class="pd-audioTitleStyle">
            {{ $t('audioDetails.playbackSpeed') }}
            <span class="pd-audioInfoStyle">{{ $t(getSpeedIns) }}</span>
          </div>
          <div class="pd-audioTitleStyle">
            {{ $t('audioDetails.audioPitch') }}
            <span class="pd-audioInfoStyle">{{ $t(getPitchIns) }}</span>
          </div>
        </div>
        <div v-if="getLoadedState" id="audio">
          <AudioPlayer :file="hostURl + '/' + audioInfo.audio_path" :autoPlay="autoPlay" :onEnd="onEnd"
            :silence="audioInfo.silence"></AudioPlayer>
        </div>
        <div v-else class="pd-transcribingShow">
          {{ audioInfo.percent }}%<span style="margin-left: 10px">{{ $t('audioDetails.converting') }}</span>
        </div>
      </div>
      <div class="pd-thingsWrapper">
        <v-btn class="pd-thingsBtn" @click="setSettingsInfo" :disabled="!getLoadedState" v-if="!isShow">
          <div style="margin-right: 10px">
            <FixIcon />
          </div>
          {{ $t('audioDetails.edit') }}
        </v-btn>
        <a :href="hostURl + '/v2/download/' + filename + '?token=' + getToken" target="_self" :download="audioInfo.name"
          style="text-decoration: none" :class="!getLoadedState ? 'disabled' : null">
          <v-btn class="pd-thingsBtn" :disabled="!getLoadedState">
            <div style="margin-right: 10px">
              <DownloadIcon />
            </div>
            {{ $t('audioDetails.download') }}
          </v-btn>
        </a>
        <v-btn class="pd-thingsBtn" @click="deleteAudio">
          <div style="margin-right: 10px">
            <DeleteIcon :width="18" :height="18" />
          </div>
          {{ $t('audioDetails.delete') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { format } from "date-fns";
import AudioPlayer from "../components/AudioPlayer";
import SettingsIcon from "../components/icons/SettingsIcon";
import FixIcon from "../components/icons/FixIcon";
import DownloadIcon from "../components/icons/DownloadIcon";
import DeleteIcon from "../components/icons/DeleteIcon";
import FullScreenInput from "../components/FullScreenInput";
import ArrowLeftIcon from "../components/icons/ArrowLeftIcon";
import { mapActions, mapState } from "vuex";
export default {
  name: "AudioDetails",
  components: {
    AudioPlayer,
    SettingsIcon,
    FixIcon,
    DeleteIcon,
    DownloadIcon,
    FullScreenInput,
    ArrowLeftIcon,
  },
  props: {
    audioInfo: { type: Object },
    deleteAudioShowDialog: { type: Function },
    setSettings: { type: Function },
    status: { type: String },
    onEnd: { type: Function },
  },
  data: () => ({
    loading: false,
    hostURl: process.env.VUE_APP_BASE_URL,
    textArray: [],
    page: 0,
    pagesCount: 0,
    isShow: false,
  }),
  created() {
    if (this.audioInfo.text.length > 3750) {
      this.isShow = true;
      this.pagesCount = Math.ceil(this.audioInfo.text.length / 3750);
      this.setPages();
    }
  },
  computed: {
    getLoadedState: function () {
      return this.status === "synthesized";
    },
    getToken() {
      return this.$cookie.get("token");
    },
    ...mapState(["allPlay", "currentAudioId"]),
    filename: function () {
      let tmp = this.audioInfo.audio_path;
      let parts = tmp.split("/");
      return (
        parts.slice(0, parts.length - 1).join("/") +
        "/" +
        this.audioInfo.name.replace(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, "") +
        "-" +
        parts[parts.length - 1]
      );
    },
    autoPlay: function () {
      if (this.allPlay) {
        if (this.currentAudioId === this.audioInfo.id) {
          return true;
        } else {
          this.stopAllPlay();
          return false;
        }
      }
      return false;
    },
    getFormatDate: function () {
      var currentDate = new Date(this.audioInfo.synthesized_date);
      currentDate.setHours(currentDate.getHours());
      return format(currentDate, "yyyy/MM/dd HH:mm");
    },
    getSpeedIns() {
      switch (this.audioInfo.speed) {
        case "0.5":
          return "audioDetails.slow";
        case "0.75":
          return "audioDetails.slower";
        case "1":
          return "audioDetails.normal";
        case "1.25":
          return "audioDetails.fast";
        case "1.5":
          return "audioDetails.faster";
        case "1.75":
          return "audioDetails.veryFast";
        default:
          return "audioDetails.unable";
      }
    },
    getVoiceName() {
      switch (this.audioInfo.voice_id) {
        case "FEMALE1":
          return "audioDetails.femaleOld";
        case "FEMALE1v2":
          return "audioDetails.female1";
        case "FEMALE2v2":
          return "audioDetails.female2";
        case "FEMALE3v2":
          return "audioDetails.female3";
        case "FEMALE4v2":
          return "audioDetails.female4";
        case "MALE1":
          return "audioDetails.maleOld";
        case "MALE1v2":
          return "audioDetails.male1";
        case "MALE2v2":
          return "audioDetails.male2";
        case "MALE3v2":
          return "audioDetails.male3";
        case "MALE4v2":
          return "audioDetails.male4";
        case "1":
          return "audioDetails.femaleOld";
        case "2":
          return "audioDetails.maleOld";
        default:
          return "audioDetails.unable";
      }
    },
    getBackgroundSound() {
      switch (this.audioInfo.background) {
        case "limbe":
          return "Лимбэ";
        case "jazz":
          return "Жазз";
        case "horror":
          return "Аймшиг";
        case "rain":
          return "Бороо";
        case "traffic":
          return "Хотын чимээ";
        case "none":
          return "Аягүй";
        case "epic":
          return "Шагнал";
        case "birthday":
          return "Төрсөн өдөр";
        case "chill":
          return "Чилл";
        case "piano":
          return "Төгөлдөр хуур";
        default:
          return "audioDetails.unable";
      }
    },

    getPitchIns() {
      switch (this.audioInfo.pitch) {
        case "0.5":
          return "audioDetails.verylowPitch";
        case "0.75":
          return "audioDetails.lowPitch";
        case "1":
          return "audioDetails.normalPitch";
        case "1.25":
          return "audioDetails.highPitch";
        case "1.5":
          return "audioDetails.highMidPitch";
        case "1.75":
          return "audioDetails.veryHighPitch";
        case "none":
          return "audioDetails.normalPitch";
        default:
          return "audioDetails.unable";
      }
    },
  },
  methods: {
    ...mapActions(["stopAllPlay"]),
    deleteAudio() {
      this.deleteAudioShowDialog(this.audioInfo.id);
    },
    setSettingsInfo() {
      var speedInt = parseFloat(this.audioInfo.speed);
      var pitchInt = parseFloat(this.audioInfo.pitch);
      const settingsInfo = {
        text: this.audioInfo.text,
        voiceId: this.audioInfo.voice_id,
        speed: speedInt,
        pitch: pitchInt,
        background: this.audioInfo.background,
      };
      this.setSettings(settingsInfo);
    },
    setPages() {
      for (var i = 0; i < this.pagesCount; i++) {
        this.textArray.push(
          this.audioInfo.text.substring(i * 3750, (i + 1) * 3750)
        );
      }
    },
    plusPage() {
      if (this.page < this.pagesCount - 1) {
        this.page++;
      }
    },
    minusPage() {
      if (this.page != 0) {
        this.page--;
      }
    },
  },
};
</script>
<style scoped>
.pd-synthesizeButton {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 40px !important;
  letter-spacing: 0;
}

.pd-subTitle {
  font-size: 14px;
  font-weight: 700;
  color: #767676;
  margin-bottom: 10px;
}

.pd-audioInfoWrapper {
  display: flex;
}

.pd-pageBtn {
  display: flex;
  border-radius: 7px;
  background-color: #777ff6;
  height: 24px;
  width: 24px;
  transition: all 0.3s;
}

.pd-textShowWrapper {
  display: flex;
  position: relative;
  flex-direction: column;
  width: 60%;
}

.pd-showText {
  display: flex;
  position: relative;
  width: 100%;
  padding: 16px;
  height: 352px;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  overflow-y: scroll;
}

.pd-pagesBtnWrapper {
  position: absolute;
  display: flex;
  width: 54px;
  justify-content: space-between;
  bottom: 70px;
  right: 10px;
}

.pd-showText::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
}

.pd-showText::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.pd-settingsWrapper {
  width: calc(40% - 40px);
  margin-left: 40px;
}

.pd-settingsTitleWrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 10px;
}

.pd-toolsWrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: 270px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  justify-content: space-between;
}

.pd-audioTitleStyle {
  font-size: 14px;
  font-weight: 500;
  color: #231f20;
  line-height: 16px;
}

.pd-audioInfoStyle {
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  line-height: 24px;
}

.pd-transcribingShow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  background-color: #7c7faf;
  color: #f7f7f7;
  font-weight: 700;
  line-height: 16px;
  font-size: 14px;
  border-radius: 6px;
}

@media screen and (max-width: 930px) {
  .pd-audioInfoWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .pd-textShowWrapper {
    width: 100%;
  }

  .pd-settingsWrapper {
    width: 100%;
    margin: 0;
  }

  .pd-toolsWrapper {
    height: auto;
  }

  .pd-pagesBtnWrapper {
    bottom: 10px;
    right: 10px;
  }
}

@media screen and (max-width: 599px) {
  .pd-subTitle {
    display: flex;
    justify-content: center;
  }
}

.pd-thingsWrapper {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.pd-thingsBtn {
  background-color: #ffffff !important;
  border: 1px solid #e5e5e5;
  text-transform: initial;
  color: #767676;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 40px !important;
  letter-spacing: 0;
  text-indent: 0;
  margin-right: 10px;
  margin-bottom: 10px;
}

a.disabled {
  pointer-events: none;
  cursor: default;
}

.pd-fullScreenButton {
  position: absolute;
  right: 16px;
  top: 36px;
}
</style>
